<template>
  <div class="account-header">
    <h4>
      {{_T('My Orders')}}
      <router-link :to="{ name: 'profile.history' }">
        <img
          class="d-sm-none"
          src="/images/svg/global/backward-time.svg"
          alt=""
        />
      </router-link>
    </h4>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
export default {
      computed: {
    ...mapGetters(['_T']),
  }
}
</script>

<style lang="scss" scoped>
  .account-header {
    border-bottom: $px1 solid $light-border;
    padding: $px18 $px30;

    h4 {
      font-weight: 600;
      margin-bottom: 0;

      .mark-cls {
        font-size: $px14;
        line-height: $px22;
        color: $color-primary;
        float: right;
      }
    }
  }
@media (max-width: 1199px) {
  .account-header {
        padding: $px20 $px30;
    }
}
@media (max-width: 991px) {
  .account-header {
        padding: $px18 $px20;
    }
}
@media (max-width: 575px) {
  .account-header {
     h4 {
       img {
        float: right;
      }
     }
  }
}
</style>